import { apiSlice } from "app/api/apiSlice"

export const wokerContractApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['ContractModel', 'WorkerContract'],
    endpoints: builder => ({
        getContractModels: builder.query({
            query: () => '/contract/model',
            keepUnusedDataFor: 5,
            providesTags: ['ContractModel']
        }),
        createContractModel: builder.mutation({
            query: (
                model
            ) => ({
                url: '/contract/model',
                method: 'POST',
                body: model
            }),
            invalidatesTags: ['ContractModel']
        }),
        // PUT Employee New Status
        editContractModel: builder.mutation({
            query: (
                model
            ) => ({
                url: '/contract/model',
                method: 'PUT',
                body: model
            }),
            invalidatesTags: ['ContractModel']
        }),
        // DELETE Employee 
        deleteContractModel: builder.mutation({
            query: contractModelGuid => {
                return {
                    url: '/contract/model',
                    method: 'DELETE',
                    params: { contractModelGuid }
                }
            },
            invalidatesTags: ['ContractModel']
        }),
        getWorkerContract: builder.query({
            query: userGUID => {
                return {
                    url: '/contract/contract',
                    params: { userGUID }
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['WorkerContract']
        }),

        // WORKER LEAVE REPORT
        getWorkerLeaveReport: builder.query({
            query: userGUID => {
                return {
                    url: '/contract/leaveReport',
                    params: { userGUID }
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['WorkerContract']
        }),
        getMyWorkerLeaveReport: builder.query({
            query: () => '/contract/leaveReport/me',
            keepUnusedDataFor: 5,
            providesTags: ['WorkerContract']
        }),
        editWorkerLeaveReport: builder.mutation({
            query: (
                workerLeaveReportEdit
            ) => ({
                url: '/contract/leaveReport',
                method: 'PUT',
                body: workerLeaveReportEdit
            }),
            invalidatesTags: ['WorkerContract']
        }),


        getAllWorkerContracts: builder.query({
            query: () => '/contract/contracts',
            keepUnusedDataFor: 5,
            providesTags: ['WorkerContract']
        }),

        getMyWorkerContract: builder.query({
            query: () => '/contract/contract/me',
            keepUnusedDataFor: 5,
            providesTags: ['WorkerContract']
        }),

        // SAVE Worker Contract
        saveWorkerContract: builder.mutation({
            query: workerContract => ({
                url: '/contract/contract',
                method: 'POST',
                body: workerContract
            }),
            invalidatesTags: ['WorkerContract']
        }),
    })
})

export const {
    useGetContractModelsQuery,
    useCreateContractModelMutation,
    useEditContractModelMutation,
    useDeleteContractModelMutation,
    useGetWorkerContractQuery,
    useGetWorkerLeaveReportQuery,
    useGetMyWorkerLeaveReportQuery,
    useEditWorkerLeaveReportMutation,
    useGetAllWorkerContractsQuery,
    useGetMyWorkerContractQuery,
    useSaveWorkerContractMutation
} = wokerContractApiSlice 